import React from 'react';

import './index.scss';

const Loading = () => {
  return (
    <div className="app-loading">
      <div className="content">Yükleniyor...</div>
    </div>
  );
};

export default Loading;
